module.exports = __webpack_public_path__ + "img/icon_sink-1.d2a8634f.png";